export default __webpack_public_path__ + "static/2-016151a1bc490a4f883dc290f4a69072.jpg";